import { useCallback, useState } from "react";
import { validateRut, validatePlate } from "../../../utils/validation";

const usePickupContact = () => {
  const [pickupContactName, setPickupContactName] = useState("");
  const [pickupContactRut, setPickupContactRut] = useState("");
  const [pickupVehiclePlate, setPickupVehiclePlate] = useState("");
  const [deliveryObservations, setDeliveryObservations] = useState("");
  const [rutError, setRutError] = useState("");
  const [plateError, setPlateError] = useState("");

  const handlePickupFieldChange = useCallback((field, value) => {
    switch (field) {
      case "name":
        setPickupContactName(value);
        break;
      case "rut":
        setPickupContactRut(value);
        setRutError(value && !validateRut(value) ? "RUT inválido. Formato: 12.345.678-9" : "");
        break;
      case "plate":
        setPickupVehiclePlate(value.toUpperCase());
        setPlateError(value && !validatePlate(value) ? "Patente inválida. Formato: XXXX11" : "");
        break;
      default:
        break;
    }
  }, []);

  const handleObservationsChange = useCallback((value) => {
    setDeliveryObservations(value);
  }, []);

  return {
    pickupContactName,
    pickupContactRut,
    pickupVehiclePlate,
    deliveryObservations,
    rutError,
    plateError,
    handlePickupFieldChange,
    handleObservationsChange,
  };
};

export default usePickupContact;